import React from 'react';
import styled from 'styled-components';
import Cards from 'components/Cards/Cards';
import CardsGroup from 'components/Cards/CardsGroup';

const IconCardsSection = ({ background, title, cards, cols, ...otherProps }) => (
  <SectionContainer data-testid="iconCardSection-container" background={background} {...otherProps}>
    <div className={otherProps.className || ''}>
      <div className="section-industry-card--container">
        {title && (
          <h2 data-testid="iconCardSection-title" className="section-industry-card--title">
            {title}
          </h2>
        )}
        <div data-testid="iconCardsSection-content" className="section-industry-card--card-content">
          {cards?.length > 0 && (
            <CardsGroup cols={cols}>
              {cards.map((cardItem, index) => (
                <Cards
                  type={'Icon'}
                  iconType={cardItem.coverIconType}
                  iconImage={cardItem.icon}
                  coverImage={cardItem.cover}
                  title={cardItem.title}
                  description={cardItem.description?.description}
                  ctaTitle={cardItem.ctaText || cardItem.buttonTitle}
                  ctaLink={cardItem.ctaLink || cardItem.linkTo}
                  key={index}
                />
              ))}
            </CardsGroup>
          )}
        </div>
      </div>
    </div>
  </SectionContainer>
);

const SectionContainer = styled.div`
  background: ${props => props.background};
  .pro .section-industry-card--container {
    padding-top: 67px;
  }
  .section-industry-card--container {
    margin: 0 auto;
    padding: 133px 28px 91px;
    max-width: 1200px;

    .section-industry-card--title {
      font-size: 49px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: var(--neutral-7);
      max-width: 784px;
      margin: 0 auto;
    }

    .section-industry-card--card-content {
      margin-top: 40px;

      .section-industry-card--card-container {
        margin-bottom: 40px;
      }
    }
  }

  @media (max-width: 768px) {
    .section-industry-card--container {
      margin: 0 auto;
      padding: 50px 40px 82px;

      .section-industry-card--title {
        font-size: 29px;
        line-height: 44px;
        max-width: 400px;
      }

      .section-industry-card--card-container {
        margin-top: 50px;

        .ant-col {
          padding-left: 8px !important;
          padding-right: 8px !important;
        }

        .industry-card--content-container {
          .industry-card--description {
            display: none;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-industry-card--container {
      margin: 0 auto;
      padding: 55px 30px 66px;

      .section-industry-card--title {
        font-size: 29px;
        line-height: 36px;
      }

      .section-industry-card--card-content {
        margin-top: 24px;

        .section-industry-card--card-container {
          margin-bottom: 0;

          & > .ant-col {
            padding: 12px 8px !important;
          }

          .industry-card--content-container {
            .industry-card--description {
              display: block;
            }
          }
        }
      }
    }
  }
`;

export default IconCardsSection;
